import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { rememberSignInReturn, signInQuery } from './sign-in-return';

export const authGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const isAuthed = await auth.isAuthenticated();
  if (isAuthed) return true;

  return router.createUrlTree(['/login'], {
    queryParams: signInQuery(rememberSignInReturn(state.url || '/home'), 'unauthenticated'),
  });
};
